<section class="pb-4 pb-lg-8">
  @if (isLoading()) {
  <ng-container *ngTemplateOutlet="skeletonCurrent"></ng-container>
  <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
  } @else {
  @if (studentCourses().length) {
  @if (lastedCourses()) {
  <h1 class="text-gray-900 mb-4">
    {{ "ONLINE_CLASS.LASTED_CLASS" | translate }}
  </h1>
  <!-- The photograph is the card's ground on the right and gone by the middle.
       It used to be a flat 70%-white veil over the whole card, which left the
       picture as a pale rectangle butted against the copy with a visible seam
       down it — and the copy sitting on top of a photo either way. The wash is
       now horizontal: opaque where the words are, clear where the picture is. -->
  <div class="card card-flush continue-card mb-10">
    <img class="continue-card__photo" aria-hidden="true" alt=""
      [src]="fileUrl + lastedCourses().student_course.course_image_url" />
    <span class="continue-card__wash" aria-hidden="true"></span>
    <!--begin::Card header-->
    <div class="card-body pb-2 pt-10">
      <div class="d-flex align-items-center">
        <div class="d-flex flex-column w-100">
          <p class="mb-2 text-primary fs-4 fw-semibold">
            {{ lastedCourses().student_course.course_name }} ({{
            "ONLINE_CLASS.LASTED" | translate
            }}
            {{ lastedCourses().updated_at | timeInterval }})
          </p>

          <h1 class="mb-1 text-overflow-line-2 col-lg-8 col-xl-9">
            {{ lastedCourses().course_chapter_group_name }}
            {{ "ONLINE_CLASS.CHAPTER" | translate }}
            {{ lastedCourses().course_chapter_name }}
          </h1>
          <div class="text-muted fs-6 fw-bold">
            <!-- <a
              class="text-info"
              >{{`ความคืบหน้า : `+ ((lastedCourses().student_course.progress || 0) | number:'1.2-2' ) + `%`}}</a
            >
            <span class="mx-3">|</span> -->
            <a class="text-gray-700">{{ "ONLINE_CLASS.SPENT_TIME" | translate }} :
              {{
              lastedCourses().student_course.duration_spent
              | durationVideo
              }}</a>
            <span class="mx-3">|</span>
            <a class="text-gray-700">{{ "ONLINE_CLASS.USABLE_TIME" | translate }} :
              {{
              lastedCourses().student_course.expire_duration_video -
              lastedCourses().student_course.duration_spent
              | durationVideo
              }}</a>
          </div>
        </div>
      </div>
    </div>
    <!--end::Card header-->

    <!--begin::Card body-->
    <div class="card-body py-6">
      <div class="d-flex overflow-auto py-2">
        <!-- <div #empty class="w-50px me-5"></div> -->
        <button class="btn btn-primary rounded-pill px-6 btn-get-started col-12 col-sm-auto"
          data-testid="continue-lasted" (click)="enterLastedCourse()">
          <div class="d-flex flex-row gap-1 align-items-center">
            <app-keenicon name="to-right" class="fs-2 svg svg-icon"></app-keenicon>
            {{ "ONLINE_CLASS.ENTER_CLASS" | translate }}
          </div>
        </button>
      </div>
      <!--begin::Navs-->
    </div>
    <!--end::Card body-->
  </div>
  }

  <h1 class="mb-4" data-testid="my-courses-heading">{{ "ONLINE_CLASS.MY_COURSE" | translate }}</h1>

  <!-- The same field the quiz list uses, because it is the same question about
       the same kind of list. eazycal puts a course search on this screen too;
       this one filters what is already loaded, since the request behind this
       page has no paging.
       The threshold is three rather than four: the seeded demo student has
       exactly three courses, and a gate that hides the field on the one
       account visitors actually use is a feature nobody can see. -->
  @if (studentCourses().length > 2) {
  <div class="pill-search mb-8">
    <div class="pill-search__field">
      <span class="pill-search__icon" aria-hidden="true">
        <app-keenicon name="magnifier" class="fs-3"></app-keenicon>
      </span>
      <input type="search" class="pill-search__input" data-testid="my-course-search" [value]="courseSearch()"
        [attr.aria-label]="'APP.SEARCH_MY_COURSE' | translate" [attr.placeholder]="'APP.SEARCH_MY_COURSE' | translate"
        (input)="onCourseSearch($any($event.target).value)" />
      @if (courseSearch().trim().length) {
      <button type="button" class="pill-search__clear" [attr.aria-label]="'QUIZ.SEARCH_CLEAR' | translate"
        (click)="onCourseSearch('')">×</button>
      }
    </div>
  </div>
  }

  <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-6">
    @for (course of visibleCourses(); track course; let i = $index) {
    <app-student-course-item class="hover-elevate-up" data-testid="student-course-card" [course]="course"
      (activateCourseEvent)="onActivateCourse($event)"></app-student-course-item>
    } @empty {
    <div class="col-12">
      <p class="fs-5 text-muted text-center py-10 mb-0" data-testid="my-course-search-empty">
        {{ "APP.SEARCH_MY_COURSE_EMPTY" | translate }}
      </p>
    </div>
    }
  </div>
  } @else {
  <!-- Somebody who has just registered lands here first. A bare grey sentence
       with nothing clickable on it is the worst possible first screen. -->
  <div class="card">
    <div class="card-body">
      <div class="empty-state" data-testid="my-courses-empty">
        <span class="empty-state__mark">
          <app-keenicon name="book-open" class="fs-2tx"></app-keenicon>
        </span>
        <p class="empty-state__title">{{ "APP.NO_COURSE_YET" | translate }}</p>
        <p class="empty-state__body">{{ "APP.NO_COURSE_YET_HINT" | translate }}</p>
        <a class="btn btn-primary" routerLink="/courses">{{ "MENU.COURSES" | translate }}</a>
      </div>
    </div>
  </div>
  }
  }
</section>

<ng-template #skeletonCurrent>
  <div class="mb-10">
    <!-- "last class" heading -->
    <div class="skeleton w-175px h-35px mb-4"></div>

    <!-- Mirrors .continue-card: min-height 15rem, photo held to the right 48%. -->
    <div class="card card-flush continue-card">
      <div class="skeleton continue-card__photo" aria-hidden="true"></div>
      <div class="card-body d-flex flex-column justify-content-between pt-10 pb-8">
        <div class="d-flex flex-column">
          <div class="skeleton w-50 mw-250px h-20px mb-4"></div>
          <div class="skeleton w-75 mw-450px h-30px mb-2"></div>
          <div class="skeleton w-50 mw-300px h-30px mb-5"></div>
          <div class="d-flex flex-row align-items-center">
            <div class="skeleton w-150px h-15px"></div>
            <span class="mx-3 text-muted">|</span>
            <div class="skeleton w-150px h-15px"></div>
          </div>
        </div>
        <div class="skeleton w-175px h-45px rounded-pill mt-8"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonGroup>
  <div class="mb-10">
    <!-- "my courses" heading -->
    <div class="skeleton w-150px h-35px mb-4"></div>
    <!-- The my-course search field (shown for 3+ courses). -->
    <div class="skeleton h-45px w-100 mw-500px mb-8"></div>

    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-6">
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
    </div>
  </div>
</ng-template>

<!-- One app-student-course-item cell: thumbnail, two-line title, then the
     progress row, its bar and the three duration lines. The .col wrapper is
     what carries the grid gutter — on the bare .card the gutter would land
     as inner padding and the cards would touch. -->
<ng-template #skeleton>
  <div class="col">
    <div class="card h-100">
      <div class="card-body d-flex flex-column">
        <div class="skeleton w-100 h-175px"></div>
        <div class="skeleton h-25px w-100 mt-8 mb-2"></div>
        <div class="skeleton h-25px w-75 mb-2"></div>

        <div class="separator my-4"></div>

        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="skeleton h-15px w-90px"></div>
          <div class="skeleton h-15px w-40px"></div>
        </div>
        <div class="skeleton h-8px w-100 rounded-pill mb-4"></div>

        <div class="d-flex align-items-center justify-content-between mt-2">
          <div class="skeleton h-10px w-100px"></div>
          <div class="skeleton h-10px w-70px"></div>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-2">
          <div class="skeleton h-10px w-90px"></div>
          <div class="skeleton h-10px w-60px"></div>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-2">
          <div class="skeleton h-10px w-100px"></div>
          <div class="skeleton h-10px w-80px"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>